"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskFactorsRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.RiskFactorsRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.risk_factors.label',
    fallbackLabel: 'Risk factors',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'JURISDICTION', label: 'fields.enm.risk_factors.options.JURISDICTION', fallbackLabel: 'Jurisdiction (geographical locations)' },
        { key: 'STRUCTURE_RISK', label: 'fields.enm.risk_factors.options.STRUCTURE_RISK', fallbackLabel: 'Structure risk' },
        { key: 'INDUSTRY_RISK', label: 'fields.enm.risk_factors.options.INDUSTRY_RISK', fallbackLabel: 'Industry risk' },
        { key: 'PEP_RISK', label: 'fields.enm.risk_factors.options.PEP_RISK', fallbackLabel: 'PEP risk' },
        { key: 'PRODUCTS_USED', label: 'fields.enm.risk_factors.options.PRODUCTS_USED', fallbackLabel: 'Products used' },
        { key: 'ADVERSE_MEDIA_RISK', label: 'fields.enm.risk_factors.options.ADVERSE_MEDIA_RISK', fallbackLabel: 'Adverse media risk' },
        { key: 'TRANSACTION_BEHAVIOR_RISK', label: 'fields.enm.risk_factors.options.TRANSACTION_BEHAVIOR_RISK', fallbackLabel: 'Transaction behavior risk' },
        { key: 'OTHER', label: 'fields.enm.risk_factors.options.OTHER', fallbackLabel: 'Other' },
    ],
    trackFieldValueWithAnalytics: false,
};
